import React, { useState } from 'react';
import { getGradeLabel } from '../utils/gradeUtils';
import PinAuth from './PinAuth';

/**
 * プロフィール切り替え画面
 * children: プロフィール一覧
 * currentId: 現在選択中のID
 * onSelect(child): 選択コールバック
 * onManage: きょうだい管理画面へ
 * onClose: 閉じる
 */
export default function ProfileSelect({ children, currentId, onSelect, onManage, onClose }) {
  const [pinTarget, setPinTarget] = useState(null); // PIN確認が必要な子

  const handleTap = (child) => {
    if (child.id === currentId) { onClose(); return; }
    // PINが設定されていればPIN確認画面へ
    if (child.pin) {
      setPinTarget(child);
    } else {
      onSelect(child);
    }
  };

  // PIN認証画面
  if (pinTarget) {
    return (
      <div className="profile-select-overlay">
        <div className="profile-select-sheet" style={{ paddingTop: 16 }} onClick={(e) => e.stopPropagation()}>
          <PinAuth
            correctPin={pinTarget.pin}
            childName={pinTarget.name}
            childAvatar={pinTarget.avatar}
            onSuccess={() => { setPinTarget(null); onSelect(pinTarget); }}
            onCancel={() => setPinTarget(null)}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="profile-select-overlay" onClick={onClose}>
      <div className="profile-select-sheet" onClick={(e) => e.stopPropagation()}>

        <div className="profile-select-handle" />

        <div className="profile-select-title">だれが　つかう？</div>

        <div className="profile-select-list">
          {children.map((child) => {
            const grade = (child.birth_year && child.birth_month)
              ? getGradeLabel(child.birth_year, child.birth_month)
              : '';
            const isActive = child.id === currentId;
            return (
              <button
                key={child.id}
                className={`profile-select-item ${isActive ? 'active' : ''}`}
                onClick={() => handleTap(child)}
              >
                <span className="profile-item-avatar">{child.avatar || '🐣'}</span>
                <span className="profile-item-name">{child.name || 'ゲスト'}</span>
                {grade && <span className="profile-item-grade">{grade}</span>}
                {child.pin && <span style={{ fontSize: 12, opacity: 0.6 }}>🔒</span>}
                {isActive && <span className="profile-item-check">✓</span>}
              </button>
            );
          })}
        </div>

        {/* ボタン行 */}
        <div className="profile-sheet-actions">
          {onManage && (
            <button className="profile-manage-btn" onClick={onManage}>
              ⚙️ きょうだいの管理
            </button>
          )}
          <button className="profile-close-btn" onClick={onClose}>
            とじる
          </button>
        </div>

      </div>
    </div>
  );
}
